import Header from "../Header";
import Step1ConnectShopify from "../Step1ConnectShopify";
import StepProgress from "../StepProgress";
import Step2ConfigureAnalysis from "../Step2ConfigureAnalysis";
import Step3RunningAnalysis from "../Step3RunningAnalysis";
import Step4Results from "../Step4Results";
import { useState } from "react";

const GuestAnalysis = ()=>{
    const [step, setStep] = useState(1);
    
      const handleNext = () => setStep((s) => Math.min(s + 1, 4));
      const handleBack = () => setStep((s) => Math.max(s - 1, 1));
      const handleComplete = () => setStep(4);


    const design = (
        <div className="bg-gray-50 min-h-screen px-4 py-8 max-w-6xl mx-auto">
      <Header />
      <StepProgress step={step} />
      {step === 1 && <Step1ConnectShopify onNext={handleNext} />}
      {step === 2 && <Step2ConfigureAnalysis onBack={handleBack} onNext={handleNext} />}
      {step === 3 && <Step3RunningAnalysis onComplete={handleComplete} setStep={setStep} />}
      {step === 4 && <Step4Results onBack={handleBack} setStep={setStep} />}
    </div>
    );
    return design;
}

export default GuestAnalysis